(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("reflux"), require("reflux-state-mixin"), require("react"), require("hadron-react-components"), require("prop-types"));
	else if(typeof define === 'function' && define.amd)
		define(["reflux", "reflux-state-mixin", "react", "hadron-react-components", "prop-types"], factory);
	else if(typeof exports === 'object')
		exports["ServerVersionPlugin"] = factory(require("reflux"), require("reflux-state-mixin"), require("react"), require("hadron-react-components"), require("prop-types"));
	else
		root["ServerVersionPlugin"] = factory(root["reflux"], root["reflux-state-mixin"], root["react"], root["hadron-react-components"], root["prop-types"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_22__, __WEBPACK_EXTERNAL_MODULE_23__, __WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_8__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition